import { render, staticRenderFns } from "./PlayerEventAccessStatusEdit.vue?vue&type=template&id=97d3851e&"
import script from "./PlayerEventAccessStatusEdit.vue?vue&type=script&lang=js&"
export * from "./PlayerEventAccessStatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports